import React, { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import {
  builderDefaultOptionsSelector,
  builderSelectedOptionsSelector,
} from '../../../../../redux/selectors/builder';
import { assertCondition } from '../../../../../utils/types';
import {
  QueryType,
  SignificanceTestKey,
} from '../../../../../utils/apollo/graphqlSchema';
import { setSignificanceTestType } from '../../../../../redux/slices/oldBuilder';
import BuilderEnumSelect from '../../../../../components/Builder/BuilderFields/BuilderEnumSelect';
import { significanceTestOptionsInfo } from '../utils/tooltips';

const SignificanceTestType = () => {
  const dispatch = useAppDispatch();

  const defaultOptions = useAppSelector(builderDefaultOptionsSelector);
  const selectedOptions = useAppSelector(builderSelectedOptionsSelector);

  assertCondition(
    defaultOptions?.type === QueryType.Significance &&
      selectedOptions?.type === QueryType.Significance,
  );

  const { tests } = defaultOptions;
  const { test } = selectedOptions;

  const handleChange = (newTestKey: SignificanceTestKey) => {
    dispatch(setSignificanceTestType({ newTestKey }));
  };

  const options = useMemo(
    () =>
      tests.map((testOption) => ({
        ...testOption,
        tooltip: significanceTestOptionsInfo[testOption.key],
      })),
    [tests],
  );

  return (
    <BuilderEnumSelect
      enumOptions={options}
      selectedOption={test}
      onChange={handleChange}
    />
  );
};

export default SignificanceTestType;
